module.exports = __webpack_public_path__ + "img/logo.d76a2a41.png";